module.exports = __webpack_public_path__ + "media/10_ASANBUDAPEST-Atmosphere10.7e8e4183.mp3";